// extracted by mini-css-extract-plugin
export var center = "_1k-2";
export var clickableRow = "_1k-5";
export var expandedRow = "_1k-7";
export var hoverable = "_1k-4";
export var left = "_1k-1";
export var right = "_1k-3";
export var row = "_1k-0";
export var selectedRow = "_1k-6";
export var summaryRow = "_1k-8";